import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFileArrowUp,
  faBoxOpen,
  faBox,
  faTruck,
  faQrcode,
  faHouseCircleCheck,
  faCalendarCheck,
  faCheck,
} from "@fortawesome/free-solid-svg-icons";

// Step structures for product and service orders
export const getProductSteps = (hasShipping) => [
  { label: "Order Placed", key: "Pending", icon: <FontAwesomeIcon icon={faFileArrowUp} /> },
  { label: "Processing Order", key: "Processing", icon: <FontAwesomeIcon icon={faBoxOpen} /> },
  hasShipping
  ? { label: "Order Shipped", key: "Shipped", icon: <FontAwesomeIcon icon={faTruck} /> }
  : { label: "Ready for Pickup", key: "Ready", icon: <FontAwesomeIcon icon={faBox} /> },
  { 
    label: "Transaction Completed", 
    key: "Complete", 
    icon: hasShipping 
      ? <FontAwesomeIcon icon={faHouseCircleCheck} /> 
      : <FontAwesomeIcon icon={faQrcode} /> 
  },
];

export const getServiceSteps = () => [
  { label: "Order Placed", key: "Pending", icon: <FontAwesomeIcon icon={faFileArrowUp} /> },
  { label: "Request Approved", key: "Approved", icon: <FontAwesomeIcon icon={faCalendarCheck} /> },
  { label: "Transaction Completed", key: "Complete", icon: <FontAwesomeIcon icon={faCheck} /> },
];

// Maps for currentStep values
export const getProductStepMap = (hasShipping) => {
  return hasShipping
    ? {
        Pending: 0,
        Processing: 1,
        Shipped: 2,
        Complete: 3,
      }
    : {
        Pending: 0,
        Processing: 1,
        Ready: 2,
        Complete: 3,
      };
};

export const serviceStepMap = {
  Pending: 0,
  Approved: 1,
  Complete: 2,
};

export const getStepsAndCurrentStep = (orderType, status, hasShipping = false) => {
  const steps = orderType === "product" ? getProductSteps(hasShipping) : getServiceSteps();
  const stepMap = orderType === "product" ? getProductStepMap(hasShipping) : serviceStepMap;

  // Ensure status matches either a key or a label in steps
  const stepKey = Object.keys(stepMap).find((key) => {
    const stepIndex = stepMap[key];
    const step = steps[stepIndex];
    return step?.key === status || step?.label === status;
  });

  return {
    steps,
    currentStep: stepMap[stepKey] ?? 0, // Default to 0 if no match is found
    stepMapName: stepKey || null,
  };
};

export const getStepMapNameByValue = (index, stepMapType, hasShipping = false) => {
  const getMap = stepMapType === "product" ? getProductStepMap() : serviceStepMap;
  const steps = stepMapType === "product" ? getProductSteps(hasShipping) : getServiceSteps();

  // Find the step name corresponding to the index
  const stepKey = Object.keys(getMap).find((key) => getMap[key] === index);

  if (stepKey) {
    const step = steps[getMap[stepKey]];
    return step?.label || null; // Return the label if found, or null
  }

  return null; // Return null if no match is found
};